import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  useLocation,
  Route,
} from "react-router-dom";
import ForgotPassword from "../../pages/forgotPassword";
import Login from "../../pages/login";
import Register from "../../pages/register";
import Profile from "../../pages/profile";
import Home from "../../pages/home";
import HeaderTop from "../common/HeaderTop";
import MenuSso from "../common/MenuSso";
import { PrivateRoute } from "../common/PrivateRoute";
import { PublicRoute } from "../common/PublicRoute";
import { ProvideAuth, useAuth } from "../../contexts/authContext";
import Footer from "../common/Footer";
import { commonUtil } from "../../utils";
import TermsAndConditions from "../../pages/termsAndConditions";
import PrivacyPolicy from "../../pages/privacyPolicy";
import Wallet from "../../pages/wallet/Wallet";
import WalletPaymentRedirect from "../../pages/wallet/WalletPaymentRedirect";

const CheckAuth = () => {
  const location = useLocation();
  const auth = useAuth();
  useEffect(() => {
    const isLoggedIn = Boolean(
      commonUtil.getAccessToken() || commonUtil.getRefreshToken()
    );
    if (!isLoggedIn) {
      auth.logout();
    }
  }, [location]);
  return null;
};

const LayoutHeader = ({ children }: { children: any }) => (
  <div className="h-full min-h-screen flex flex-col items-center justify-between">
    <div className="w-full">
      <HeaderTop />
      <MenuSso />
    </div>
    <CheckAuth />
    {children}
    <div className="w-full">
      <Footer />
    </div>
  </div>
);

const LayoutNoHeader = ({ children }: { children: any }) => <>{children}</>;

const Layout = () => {
  return (
    <Router>
      <ProvideAuth>
        <Router>
          <Switch>
            <Route path={["/payment"]}>
              <LayoutHeader>
                <Switch>
                  <PrivateRoute path="/payment">
                    <WalletPaymentRedirect />
                  </PrivateRoute>
                </Switch>
              </LayoutHeader>
            </Route>

            <Route path={["/wallet"]}>
              <LayoutNoHeader>
                <Switch>
                  <PrivateRoute path="/wallet">
                    <Wallet />
                  </PrivateRoute>
                </Switch>
              </LayoutNoHeader>
            </Route>

            <Route
              path={[
                "/dieu-khoan-su-dung",
                "/chinh-sach-bao-mat",
                "/login",
                "/profile",
                "/register",
                "/forgot-password",
                "/",
                "/profile",
              ]}
            >
              <LayoutHeader>
                <Switch>
                  <PublicRoute
                    path="/dieu-khoan-su-dung"
                    restricted={false}
                    exact={true}
                  >
                    <TermsAndConditions />
                  </PublicRoute>
                  <PublicRoute
                    path="/chinh-sach-bao-mat"
                    restricted={false}
                    exact={true}
                  >
                    <PrivacyPolicy />
                  </PublicRoute>
                  <PublicRoute path="/login" restricted={true} exact={true}>
                    <Login />
                  </PublicRoute>
                  <PublicRoute path="/register" restricted={true} exact={true}>
                    <Register />
                  </PublicRoute>
                  <PublicRoute
                    path="/forgot-password"
                    restricted={true}
                    exact={true}
                  >
                    <ForgotPassword />
                  </PublicRoute>
                  <PrivateRoute path="/" exact={true}>
                    <Home />
                  </PrivateRoute>
                  <PrivateRoute path="/profile">
                    <Profile />
                  </PrivateRoute>
                </Switch>
              </LayoutHeader>
            </Route>
          </Switch>
        </Router>
      </ProvideAuth>
    </Router>
  );
};

export default Layout;
